import { SEARCH_INSPIRATION } from '../../constants/ApiEndpoints'
import { requestHelper } from '../../utils/reduxActionUtils'
import {
  clearData,
  getSearchFeed,
  getSearchFeedPagination
} from './InspirationFeedAction'
import { setLikes } from './LikeAction'

const PAGE_LIMIT = 48
export const searchByWord = (word, page) => {
  if (!page) page = 0

  const requestBody = {
    text: word,
    pageLimit: PAGE_LIMIT,
    skip: page * PAGE_LIMIT,
    kinds: ['featured']
  }

  //get header and request body
  const appendant = requestHelper(requestBody)

  //getFeed(json.result.userInspirations)
  return async (dispatch, getState) => {
    const state = getState()

    try {
      if (page < 1) dispatch(clearData())
      const response = await fetch(SEARCH_INSPIRATION, appendant)

      const responseJson = await response.json()

      let { result } = responseJson

      if (!state.auth.isAuthenticated) {
        result.userInspirations = result.userInspirations.slice(0, 6)
      }

      if (page < 1) dispatch(getSearchFeed(result, word))
      else {
        dispatch(getSearchFeedPagination(result, word, page))
      }

      dispatch(setLikes(responseJson.result))
    } catch (error) {}
  }
}
